import React from 'react';
import Layout from '../../../components/Layout';
import PageNotFound from './PageNotFound';

async function action() {
  return {
    title: 'Page Not Found',
    component: (
      <Layout>
        <PageNotFound />
      </Layout>
    ),
  };
}

export default action;
